import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import shareUrl from '../helpers/shareUrl';
export default class ShareLinkButton extends Component {
  view() {
    return m(Button, {
      "aria-label": extractText(app.translator.trans('davwheat-share.lib.share_a11y_label')),
      onclick: () => shareUrl(this.attrs.url, this.attrs.discussionTitle),
      className: "Button Button--link davwheat-ShareLinkButton"
    }, app.translator.trans('davwheat-share.lib.share'));
  }
}
flarum.reg.add('davwheat-share', 'common/components/ShareLinkButton', ShareLinkButton);